// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail-page[data-v-65800f5a]{height:calc(100% - 1000px)}@media (max-width:896px){.detail-page[data-v-65800f5a]{height:100%}}", ""]);
// Exports
module.exports = exports;
